import React from 'react';
import { SettingsLayout } from '../components/SettingsLayout';
import { AnnualAndPeriods } from '../components/AnnualsAndPeriods';

export const AnnualAndPeriodsPage = () => {
  return (
    <SettingsLayout activeTab="annualsAndPeriods">
      <AnnualAndPeriods />
    </SettingsLayout>
  );
};
